import useQueryState from '../useQueryState';
import {LanguageType} from '../../model';

const key = ['language'];
const useLanguage = (initial: LanguageType = 'en') => {
  const [value, setValue] = useQueryState<LanguageType>(key, initial);
  return {value, setValue};
};

export default useLanguage;
